// BNB
export const DEFAULT_INPUT_CURRENCY = 'BNB'
// HODLX
export const DEFAULT_OUTPUT_CURRENCY = '0xAeBdbcc7d6821E3924EE5167b4138a43c19Cf681'
/*
// HODL
export const DEFAULT_OUTPUT_CURRENCY = '0x0E9766dF73973abCfEDDE700497c57110ee5c301'
*/